import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";
import { L } from "@/components/ideaos/shared";

const TONE = { captured: "text-slate-600 bg-slate-100", defined: "text-sky-700 bg-sky-50", explored: "text-violet-700 bg-violet-50", tested: "text-indigo-700 bg-indigo-50", proven: "text-emerald-700 bg-emerald-50",
  validated: "text-white bg-emerald-600", building: "text-amber-700 bg-amber-50", launched: "text-emerald-800 bg-emerald-100", hidden: "text-slate-500 bg-slate-100", parked: "text-slate-500 bg-slate-100", archived: "text-slate-400 bg-slate-50" };
const MANUAL = ["hidden", "parked", "archived"];

/** Automatic stage (Da esplorare → … → Validata, driven by decisions + CCI + evidence) with optional manual tags that override it. */
export function MaturityTag({ project, onChanged }) {
  const { t, lang } = useLang();
  const [busy, setBusy] = useState(false);
  const value = project.manual_maturity || "auto";
  const change = async (v) => {
    setBusy(true);
    try { const { data } = await api.patch(`/projects/${project.id}/maturity`, { maturity: v }); onChanged?.(data.maturity, data.manual_maturity); toast.success(L(lang, "Tag aggiornato", "Tag updated")); }
    catch { toast.error(L(lang, "Non riuscito", "Failed")); }
    finally { setBusy(false); }
  };
  return (
    <span className={`relative inline-flex h-8 items-center gap-1 rounded-full pl-3 pr-2 text-[11px] font-semibold uppercase tracking-wider ${TONE[project.maturity] || TONE.captured}`} data-testid="maturity-tag" title={L(lang, "Il tag automatico segue decisioni, CCI ed evidenze. Puoi coprirlo con un tag manuale.", "The automatic tag follows decisions, CCI and evidence. You can override it with a manual tag.")}>
      {t(`maturity.${project.maturity || "captured"}`)}
      <ChevronDown size={11} className="opacity-60" />
      <select value={value} disabled={busy} onChange={(e) => change(e.target.value)} aria-label={L(lang, "Tag idea", "Idea tag")} data-testid="maturity-tag-select" className="absolute inset-0 cursor-pointer opacity-0">
        <option value="auto">{L(lang, "Automatico", "Automatic")}</option>
        {MANUAL.map((m) => <option key={m} value={m}>{t(`maturity.${m}`)}</option>)}
      </select>
    </span>
  );
}
